export default __webpack_public_path__ + "static/media/reset-pass.62e5b98c.svg";